/**
 * @fileOverview This file contains the implementation of the AcquireDialog used in AcquireScreen.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import PropTypes from "prop-types";
import { useTranslationHook } from "../../hooks/UseTranslationHook";

/**
 * AcquireDialog component to notify the user that the request has been sent
 *
 * @param {State} {open} - State of dialogOpen
 * @param {Function} {setOpen} - Function to change state of dialogOpen
 * @returns {Component} AcquireDialog component
 */
const AcquireDialog = ({ open, onClose }) => {
  const {
    acquireDialogTitleStr,
    acquireDialogContentStr,
    acquireDialogCloseStr,
  } = useTranslationHook();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{acquireDialogTitleStr}</DialogTitle>
      <DialogContent>
        <DialogContentText>{acquireDialogContentStr}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          {acquireDialogCloseStr}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AcquireDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AcquireDialog;
